export enum CashRegisterStatus {
  GatewayDisconnected,
  Outdated,
  Unreachable,
  Active,
}
